export const HEADER_TABLE_NAMES = [
  "Nazwa",
  "Data utworzenia",
  "Data wygaśnięcia",
  "Data użycia",
];
